import { render, staticRenderFns } from "./SchoolsModal.vue?vue&type=template&id=5381330a&scoped=true&"
import script from "./SchoolsModal.vue?vue&type=script&lang=js&"
export * from "./SchoolsModal.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsModal.vue?vue&type=style&index=0&id=5381330a&prod&lang=css&"
import style1 from "./SchoolsModal.vue?vue&type=style&index=1&id=5381330a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381330a",
  null
  
)

export default component.exports